global.ToggleNearest = function(element) {
  element.click(function() {
    var div = element.data('div');
    element.children(div).slideToggle(200);
  });
};
